export default "__VITE_ASSET__rKIOs8H3__"